import React from 'react'
import styles from '../style/Settings.module.css'
import Supscription from './Supscription'
import MyProfile from './MyProfile'


import {
    BrowserRouter as Router,
    Switch,
    Route,
    NavLink
  } from "react-router-dom";


const Settings = () => (
  <div id="Settings">
      <Router>
            <div id={styles.Settings}>
                <div id={styles.Navbar}>
                  <NavLink to="/Settings" activeClassName={styles.outsideItemActive} className={styles.outsideItem}>
                     <button className={styles.switchButton}> My profile </button>
                 </NavLink>

                 <NavLink to="/Supscription" activeClassName={styles.outsideItemActive} className={styles.outsideItem}>
                      <button className={styles.switchButton}> Subscription </button>
                 </NavLink>
                </div>
                <Switch>
                     <div id={styles.insideContent}>
                        <Route exact path="/Settings">
                             <MyProfile /> 
                        </Route>
                        <Route path="/Supscription">
                            <Supscription />
                        </Route>
                        </div>
                </Switch>
             </div>
        </Router>  
  </div>
)


export default Settings;
